import gql from 'graphql-tag'

import { AuthGetMeQuery } from '../../../types/api'

export default {
  query: gql`
    query AuthGetMe {
      me {
        id
        token
        locale
        first_name
        last_name
        email
        disclaimer_accepted
        numberAppointmentsLeft
        numberAppointmentsLeftIsReturn
        numberAppointmentsLeftNotIsReturn
        appointments {
          id
          first_name
          last_name
          email
          message
          slot {
            id
            opening_hour
            closing_hour
            store {
              id
            }
          }
        }
      }
    }
  `,
  transformer: (response: AuthGetMeQuery) => {
    return response.me
  },
}
